import { mergeAttributes, Node } from "@tiptap/core";

export interface ToolInlineBlockOptions {
  HTMLAttributes: Record<string, any>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    toolInlineBlock: {
      /**
       * Add a tool inline block
       */
      setToolInlineBlock: (attributes: { tool: string }) => ReturnType;
    };
  }
}

export const ToolInlineBlock = Node.create<ToolInlineBlockOptions>({
  name: "toolInlineBlock",

  addOptions() {
    return {
      HTMLAttributes: {
        class: "bg-editor-mention-blue/10 text-editor-mention-blue inline p-1 rounded-md",
        onclick: (e: Event) => {
          e.preventDefault();
          e.stopPropagation();
        },
      },
    };
  },

  group: "inline",

  inline: true,

  selectable: false,

  atom: false,

  addAttributes() {
    return {
      tool: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-tool"),
        renderHTML: (attributes) => {
          if (!attributes.tool) return {};
          return {
            "data-tool": attributes.tool,
            class: "bg-editor-mention-blue/10 text-editor-mention-blue inline px-1 rounded-md",
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-tool]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const tool = HTMLAttributes["data-tool"];
    return [
      "span",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      tool ? `@${tool}` : "",
    ];
  },

  renderText({ node }) {
    return `@${node.attrs.tool || ""}`;
  },

  addCommands() {
    return {
      setToolInlineBlock:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
});
